import styleInject from 'style-inject';

var css_248z = ".ThemeWrapper-module_themeMarker__kzLNs {\n\tposition: absolute;\n\tvisibility: hidden;\n\twidth: 0;\n\theight: 0;\n}\n\n.ThemeWrapper-module_themeContainer__HnwuH {\n\theight: 100%;\n\ttransition: color 0.2s, background 0.2s;\n\tcolor: var(--qd-color-text-1);\n\tbackground: var(--qd-color-main-bg);\n}\n";
var styles = {"themeMarker":"ThemeWrapper-module_themeMarker__kzLNs","themeContainer":"ThemeWrapper-module_themeContainer__HnwuH"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
